import * as React from "react";
import {Stack} from "@mui/material";
import SubscriptionConfigurationTable from "../tables/SubscriptionConfigurationTable";

function SubscriptionConfiguration({legalEntity, dealer}: {legalEntity: string, dealer: string}) {

    return (
        <Stack direction={'column'} spacing={2} margin={"16px"}>
            <SubscriptionConfigurationTable legalEntity={legalEntity} dealer={dealer}/>
        </Stack>
    )
}

export default SubscriptionConfiguration;